import * as React from 'react';

export interface IUserPopinContext {
    showPopin: boolean;
    togglePopin: () => void;
}

export const UserPopinContext = React.createContext<IUserPopinContext>(null);
